import { useQuery } from '@tanstack/react-query';
import { platformCortexApi } from '../services/api';

export function usePlatformCortexLatest() {
  return useQuery({
    queryKey: ['platform-cortex', 'latest'],
    queryFn: () => platformCortexApi.getLatest(),
    staleTime: 5 * 60 * 1000, // 5 min — cortex versions change infrequently
  });
}
